module.exports = __webpack_public_path__ + "img/resolve the scarlet mist incident.59ec15ae.png";